export default from './InputQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/InputQuestion/index.js